import { render } from "./purchaseDetails.vue?vue&type=template&id=7cb0127a&scoped=true"
import script from "./purchaseDetails.vue?vue&type=script&lang=js"
export * from "./purchaseDetails.vue?vue&type=script&lang=js"

import "./purchaseDetails.vue?vue&type=style&index=0&id=7cb0127a&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb0127a"]])

export default __exports__